<template>
  <div class="amazon-image-display">
    <div class="row">
      <label class="col-sm-4 col-form-label">{{ field.label }}</label>
      <div class="col-sm-8">
        <img v-bind:src="'https://techcar-dev.s3.amazonaws.com/'+ ( field.value ? field.value : 'spacer.gif' ) + '?v=' + new Date().getTime()"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AmazonImageDisplay',
  props: {
    field: {
      type: Object,
      default () {
        return {
          value: '',
          valid: false,
          dirty: false
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/AmazonImageDisplay.vue